import React from "react";
import axios from "axios";
import Form from "react-validation/build/form";

import { BACKEND_CONFIG } from "../../config/consts";
import Input from "../../components/Input";
import Script from "../../utils/load-script";
import { required, routingNumberValidator } from "../../validation/validation";

import "../../styles/collect-payment-page.scss";

export class NewBankAccount extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      frontErrors: null,
      tokenEXData: null,
      iframeConfig: undefined,
      firstName: "",
      middleName: "",
      lastName: "",
      routingNumber: "",
      isTokenValid: true,
    };

    this.formRef = React.createRef();
  }

  componentDidMount() {
    this.props.paymentform(this.formRef);
    this.tokenExLoadSettings();
  }

  updateData = (e) => {
    const field = e.target.name;

    this.setState({ [field]: e.target.value });
    this.props.onUpdate({ [field]: e.target.value });
  };

  tokenExLoadSettings() {
    axios
      .get(BACKEND_CONFIG.apiUrl + "collect-payment/tokenex-nonpci")
      .then((data) => {
        this.setState({
          tokenEXData: data.data,
          iframeConfig: {
            styles: {
              base: "height: 44px; width: 100%; font-family: 'Open Sans'; font-size: 16px; line-height: inherit; overflow: visible; box-sizing: border-box; padding: 10px 11px; border-radius: 4px; background: initial; box-shadow: inset 0 2px 2px 0 rgba(132, 130, 156, 0.2); background-color: #fff; border: solid 1px #b0aeca; } @font-face{ font-family: 'Open Sans'; font-style: normal; font-weight: 400; src: local('Open Sans Regular'), local('OpenSans-Regular'),  url(https://fonts.gstatic.com/s/roboto/v18/KFOmCnqEu92Fr1Mu4mxMKTU1Kg.woff) format('woff'), url(https://fonts.gstatic.com/s/opensans/v15/mem8YaGs126MiZpBA-UFVZ0b.woff2) format('woff2'); unicode-range: U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+2000-206F, U+2074, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD;} input:-ms-input-placeholder{color: #85839c} input::placeholder{color: #85839c} input::-webkit-input-placeholder{color: #85839c}",
              focus:
                "outline: -webkit-focus-ring-color auto 8px; border-radius: 4px;  outline-offset: -2px;",
              error:
                "background-color: rgba(236, 88, 64, 0.1) !important; border-color: #eb3661 !important;",
            },
            pci: false,
            inputType: "text",
            debug: false,
            placeholder: "XXXXXXXXXXXXXXXX",
            origin: window.location.origin,
            timestamp: data.data.Timestamp,
            tokenExID: data.data.Id,
            tokenScheme: data.data.Scheme,
            authenticationKey: data.data.HMAC,
            enableValidateOnBlur: true,
            scriptUrl: data.data.ScriptUrl,
          },
        });
      });
  }

  tokenEXConfig() {
    window.elements = {
      iframe: null,
    };

    window.elements.iframe = new window.TokenEx.Iframe(
      "tokenExIframeDiv",
      this.state.iframeConfig
    );

    this.props.iFrameRef(window.elements.iframe);

    window.elements.iframe.on("tokenize", (data) => {
      this.props.onTokenize({
        token: data.token,
        referenceNumber: data.referenceNumber,
      });
    });

    window.elements.iframe.on("validate", (data) => {
      this.setState({ isTokenValid: data.isValid });
      this.props.onPANValidate(data.isValid);
    });

    window.elements.iframe.load();
  }

  submitMethod() {
    window.elements.iframe.tokenize();
  }

  render() {
    return (
      <div className="new-method">
        {this.state.iframeConfig && (
          <Script
            url={this.state.iframeConfig.scriptUrl}
            onLoad={() => this.tokenEXConfig()}
          />
        )}

        <Form ref={this.formRef} autoComplete="off">
          <div className="form-group account-holder">
            <div style={{ float: "left", marginRight: "18px", width: "161px" }}>
              <label htmlFor="firstName">First Name</label>
              <Input
                value={this.state.firstName}
                type="text"
                id="firstName"
                name="firstName"
                autoComplete="off"
                onChange={this.updateData}
                onBlur={this.updateData}
                validations={[required]}
              />
            </div>
            <div style={{ float: "left", marginRight: "18px", width: "101px" }}>
              <label htmlFor="middleName">Middle Name</label>
              <Input
                value={this.state.middleName}
                type="text"
                id="middleName"
                name="middleName"
                autoComplete="off"
                onChange={this.updateData}
                onBlur={this.updateData}
              />
            </div>
            <div style={{ display: "inline-block", width: "170px" }}>
              <label htmlFor="lastName">Last Name</label>
              <Input
                value={this.state.lastName}
                type="text"
                id="lastName"
                name="lastName"
                autoComplete="off"
                onChange={this.updateData}
                onBlur={this.updateData}
                validations={[required]}
              />
            </div>
            <div className="clear" />
          </div>
          <div className="form-group routing-number">
            <label htmlFor="routingNumber">Routing Number</label>
            <Input
              value={this.state.routingNumber}
              type="text"
              id="routingNumber"
              name="routingNumber"
              placeholder="XXXXXXXXX"
              onBlur={this.updateData}
              length="9"
              validations={[required, routingNumberValidator]}
            />
          </div>
          <div className="account-number">
            <label>Account Number</label>
            <div id="tokenExIframeDiv" />
            <div className="form-group">
              <div
                className={
                  this.state.isTokenValid
                    ? "hide-item"
                    : "error-message is-visible"
                }
              >
                Invalid bank account number
              </div>
            </div>
          </div>
        </Form>
      </div>
    );
  }
}
